import React from 'react'
import CircularProgress from '@mui/material/CircularProgress';

const ButtonLoader = ({
    children,
    colorProgress = 'var(--color-white)',
    size_progress = '22px',
    type = 'button',
    className = '',
    custom_styles = {},
    custom_key = '',
    state_progress = false,
    onClick = (() => { }),
    parameters = null,
}) => {
    function clickButton(event) {
        event.preventDefault();
        event.stopPropagation();

        onClick(parameters);
    }

    return (
        <button type={type} className={className} style={custom_styles} key={custom_key} disabled={state_progress} onClick={clickButton}>
            {
                state_progress ? (<CircularProgress size={size_progress} style={{ color: colorProgress }} />) : children
            }
        </button>
    )
}

export default ButtonLoader